var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinnerContainer"},[_c('looping-rhombuses-spinner',{attrs:{"animation-duration":2500,"color":_vm.mainGreen,"rhombus-size":15}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }